export const openInquiry = (source = "Website Inquiry") => {
  window.dispatchEvent(new CustomEvent("open-inquiry", { detail: { source } }));
};
